module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Done-circle-7b00e1eb5bef03a68b7bdbb1e38bee7c.svg";